import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { BUSINESS } from "../data/site";

const isOpenNow = () => {
  const d = new Date();
  const day = d.getDay();
  const t = d.getHours() + d.getMinutes() / 60;
  if (day === 0) return false;
  if (day === 6) return t >= 9 && t < 17;
  return t >= 9 && t < 18;
};

export const TopBar = () => {
  const open = isOpenNow();
  return (
    <div data-testid="top-bar" className="bg-white border-b border-line text-xs sm:text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between gap-4 h-11">
        <a
          data-testid="topbar-address-link"
          href={BUSINESS.mapsPlace}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex items-center gap-2 text-slate-600 hover:text-volt transition-colors duration-300"
        >
          <MapPin className="w-4 h-4 text-volt" />
          <span>{BUSINESS.fullAddress}</span>
        </a>
        <div className="flex items-center gap-5 sm:gap-8 mx-auto md:mx-0">
          <a
            data-testid="topbar-email-link"
            href={BUSINESS.emailHref}
            className="hidden sm:flex items-center gap-2 text-slate-600 hover:text-volt transition-colors duration-300"
          >
            <Mail className="w-4 h-4 text-volt" />
            {BUSINESS.email}
          </a>
          <span data-testid="topbar-hours" className="hidden lg:flex items-center gap-2 text-slate-600 font-semibold uppercase tracking-wide text-[11px]">
            <Clock className="w-4 h-4 text-volt" />
            {BUSINESS.hoursShort}
          </span>
          <a
            data-testid="topbar-phone-link"
            href={BUSINESS.phoneHref}
            className="hidden xs:flex sm:flex items-center gap-2 font-bold text-volt hover:text-volt-hover transition-colors duration-300"
          >
            <Phone className="w-4 h-4" />
            {BUSINESS.phone}
          </a>
          <span data-testid="topbar-open-badge" className="flex items-center gap-1.5 font-bold text-xs">
            <span className={`w-2 h-2 rounded-full ${open ? "bg-green-500" : "bg-red-500"}`} aria-hidden="true" />
            <span className={open ? "text-green-600" : "text-red-600"}>{open ? "Open Now" : "Closed"}</span>
          </span>
        </div>
      </div>
    </div>
  );
};
